export default {
  bind(el, binding) {
    el.querySelectorAll('tr').forEach((el, idx) => {
      if (idx + 1 > binding.value.length) {
        el.style.display = 'none';
      }
    });
  },
  update(el, binding) {
    const oldLength = binding.oldValue.length;
    const thisLength = binding.value.length;
    const oldShowCheck = binding.oldValue.showCheck;
    const thisShowCheck = binding.value.showCheck;
    const oldYear = binding.oldValue.year;
    const thisYear = binding.value.year;
    const btn = el.parentNode.nextSibling;
    if (thisShowCheck) {
      if (
        oldLength === thisLength &&
        oldShowCheck === thisShowCheck &&
        oldYear === thisYear
      ) {
        return false;
      }
      setTimeout(() => {
        const tr = el.querySelectorAll('tr');
        const trLength = tr.length;
        tr.forEach((el, idx) => {
          if (idx < thisLength) {
            el.style.display = 'table-row';
          } else {
            el.style.display = 'none';
          }
        });

        if (thisLength >= trLength) {
          btn.style.display = 'none';
        } else {
          btn.style.display = 'block';
        }
      }, 1);
    }
  }
};
